<template>
  <div class="agent-floating">
    <!-- 浮动入口按钮 -->
    <div
        v-if="!visible"
        class="floating-btn"
        @click="visible = true">
      <i class="el-icon-s-promotion"/>
      <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
    </div>

    <!-- 右侧半框面板 -->
    <transition name="slide-right">
      <div v-show="visible" class="chat-panel">
        <!-- 头部 -->
        <div class="panel-header">
          <div class="panel-header-left">
            <i class="el-icon-s-promotion" style="color: #2d8cf0; font-size: 18px; margin-right: 6px"/>
            <span>智能体问答</span>
          </div>
          <div class="panel-header-right">
            <el-tooltip content="折叠到右侧" placement="bottom">
              <i class="el-icon-d-arrow-right collapse-btn" @click="visible = false"/>
            </el-tooltip>
          </div>
        </div>

        <!-- 消息列表 -->
        <div ref="messageList" class="panel-body">
          <div v-if="messages.length === 0" class="empty-state">
            <i class="el-icon-chat-dot-round empty-icon"/>
            <p class="empty-text">您好！我是智能助手，有什么可以帮助您的？</p>
            <div class="quick-questions">
              <el-tag
                  v-for="(q, index) in quickQuestions"
                  :key="index"
                  class="quick-tag"
                  effect="plain"
                  @click="sendQuickQuestion(q)">
                {{ q }}
              </el-tag>
            </div>
          </div>
          <div v-for="(msg, index) in messages" :key="index" class="msg-wrapper">
            <div v-if="msg.role === 'assistant'" class="msg-row msg-ai">
              <div class="avatar avatar-ai">
                <i class="el-icon-s-promotion"/>
              </div>
              <div class="msg-content">
                <div class="bubble bubble-ai">
                  <div v-if="msg.loading" class="typing-indicator">
                    <span class="dot"/><span class="dot"/><span class="dot"/>
                  </div>
                  <div v-else>{{ msg.content }}</div>
                </div>
              </div>
            </div>
            <div v-else class="msg-row msg-user">
              <div class="msg-content">
                <div class="bubble bubble-user">{{ msg.content }}</div>
              </div>
              <div class="avatar avatar-user">
                <i class="el-icon-user-solid"/>
              </div>
            </div>
          </div>
          <div id="msg-end"/>
        </div>

        <!-- 输入区 -->
        <div class="panel-footer">
          <div class="input-wrap">
            <el-input
                ref="chatInput"
                v-model="inputText"
                type="textarea"
                :rows="2"
                placeholder="请输入问题..."
                resize="none"
                @keydown.enter.native.prevent="sendMessage"
                @keydown.ctrl.enter.native.prevent="sendMessage"/>
          </div>
          <div class="input-actions">
            <span class="input-hint">Enter 发送 / Ctrl+Enter 换行</span>
            <el-button
                type="primary"
                size="mini"
                :loading="sending"
                :disabled="!inputText.trim()"
                @click="sendMessage">
              发送
            </el-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import dateUtil from "@/util/dateUtil";

  export default {
    name: "AgentChat",
    data() {
      return {
        visible: false,
        inputText: "",
        sending: false,
        unreadCount: 1,
        messages: [],
        quickQuestions: [
          "系统有哪些功能模块？",
          "如何创建新订单？",
          "权限管理怎么配置？",
        ],
      };
    },
    watch: {
      visible(val) {
        if (val) {
          this.unreadCount = 0;
          this.$nextTick(() => {
            this.scrollToBottom();
            if (this.$refs.chatInput) {
              this.$refs.chatInput.focus();
            }
          });
        }
      },
    },
    methods: {
      sendMessage() {
        const text = this.inputText.trim();
        if (!text || this.sending) return;
        this.inputText = "";

        this.messages.push({role: "user", content: text});
        this.scrollToBottom();

        const aiIndex = this.messages.length;
        this.messages.push({role: "assistant", content: "", loading: true});
        this.sending = true;

        this.$http
            .post("basic", "agent/chat", {question: text})
            .then((resp) => {
              this.messages[aiIndex] = {
                role: "assistant",
                content: resp.reply || resp.data || "暂无回复",
                loading: false,
              };
            })
            .catch(() => {
              this.messages[aiIndex] = {
                role: "assistant",
                content: "抱歉，我暂时无法回答，请稍后重试或联系管理员。",
                loading: false,
              };
            })
            .finally(() => {
              this.sending = false;
              this.scrollToBottom();
            });
      },
      sendQuickQuestion(question) {
        this.inputText = question;
        this.sendMessage();
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const el = this.$refs.messageList;
          if (el) el.scrollTop = el.scrollHeight;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.agent-floating {
  position: fixed;
  z-index: 2000;
  right: 0;
  bottom: 0;
  pointer-events: none;

  * {
    pointer-events: auto;
  }
}

/* 浮动按钮 */
.floating-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2d8cf0, #5ba3f5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(45, 140, 240, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
  z-index: 2001;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 20px rgba(45, 140, 240, 0.5);
  }
}

.unread-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #f56c6c;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  box-shadow: 0 0 0 2px #fff;
}

/* 右侧面板 */
.chat-panel {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 480px;
  max-width: calc(100vw - 60px);
  background: #fff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 2002;
}

/* 滑入动画 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
}

/* 头部 */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebeef5;
  background: #fafbfc;
  flex-shrink: 0;
}

.panel-header-left {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.collapse-btn {
  font-size: 18px;
  color: #909399;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: #ebeef5;
    color: #606266;
  }
}

/* 消息列表 */
.panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9fb;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 260px;
}

.empty-icon {
  font-size: 48px;
  color: #dcdfe6;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 14px;
  color: #909399;
  margin: 0 0 20px 0;
}

.quick-questions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.quick-tag {
  cursor: pointer;
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 14px;
  border: 1px solid #d9ecff;
  color: #2d8cf0;
  background: #ecf5ff;

  &:hover {
    background: #2d8cf0;
    color: #fff;
    border-color: #2d8cf0;
  }
}

.msg-wrapper {
  margin-bottom: 14px;
}

.msg-row {
  display: flex;
  align-items: flex-start;
}

.msg-user {
  justify-content: flex-end;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.avatar-ai {
  background: linear-gradient(135deg, #2d8cf0, #5ba3f5);
  color: #fff;
  margin-right: 8px;
}

.avatar-user {
  background: #c0c4cc;
  color: #fff;
  margin-left: 8px;
}

.msg-content {
  max-width: 75%;
}

.bubble {
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-word;
  white-space: pre-wrap;
}

.bubble-ai {
  background: #fff;
  border: 1px solid #ebeef5;
  border-top-left-radius: 3px;
  color: #303133;
}

.bubble-user {
  background: #2d8cf0;
  color: #fff;
  border-top-right-radius: 3px;
}

/* 打字指示器 */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px 0;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c0c4cc;
  animation: typing 1.4s infinite ease-in-out;
}

.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing {
  0%, 60%, 100% { opacity: 0.3; transform: scale(0.8); }
  30% { opacity: 1; transform: scale(1); }
}

/* 输入区 */
.panel-footer {
  padding: 10px 12px 14px;
  border-top: 1px solid #ebeef5;
  background: #fafbfc;
  flex-shrink: 0;
}

.input-wrap {
  :deep textarea {
    border-radius: 8px;
    font-size: 13px;
    border-color: #dcdfe6;
    transition: border-color 0.2s;
    &:focus { border-color: #2d8cf0; }
  }
}

.input-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}

.input-hint {
  font-size: 11px;
  color: #c0c4cc;
}
</style>
